module.exports = __webpack_public_path__ + "static/media/construction-hammer.14e35f22.svg";